import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { FC } from 'react';
import { colorTokens } from '../design-system/tokens';

type WindowWrapperProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

export const WindowWrapper: FC<WindowWrapperProps> = ({ children, sx }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: 'calc(100vw - 32px)',
        maxHeight: 'calc(100vh - 32px)',
        overflow: 'auto',
        bgcolor: colorTokens.slate950Alpha95,
        boxShadow: 24,
        border: (theme) =>
          `1px solid ${theme.designSystem.surface.headerDivider}`,
        borderRadius: 1,
        p: 1.5,
        ...sx
      }}
    >
      {children}
    </Box>
  );
};
